import ApiService from "@/common/api.service";
import {
  FETCH_USERS,
  CREATE_USER,
  UPDATE_USER,
  CHANGE_PASSWORD
} from "../actions.type";
import { SET_USERS } from "../mutations.type";

const state = {
  users: []
};

const getters = {
  users(state) {
    return state.users;
  }
};

const mutations = {
  [SET_USERS](context, newusers) {
    state.users = newusers;
  }
};

const actions = {
  [FETCH_USERS](context, data) {
    return ApiService.post("/user/list", data).then(users => {
      context.commit(SET_USERS, users);
      return Promise.resolve(users);
    });
  },

  [CREATE_USER](context, data) {
    return ApiService.post("/user/create", data);
  },

  [UPDATE_USER](context, data) {
    return ApiService.post("/user/update", data);
  },

  [CHANGE_PASSWORD](context, data) {
    return ApiService.post("user/changePassword", data);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
